import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import Button from '../../../../components/Button/Button'
import { addAffiliateBilling } from '../../../../features/payment/paymentSlice'
import { showSnackBar } from '../../../../components/Snackbar/Snackbar'

// The one action an affiliate-billed enrolment needs that an ordinary one does not.
//
// Dolly, 7 Sep 2026: "maybe we create a button where we skip payment plan, payment method." This is
// that button. It gives the client the affiliate billing method, which is what lets the rest of the
// screen work: the LSA becomes previewable and sendable, and "Send email" stops offering the old
// "add your bank account" link.
//
// Deliberately NOT automatic. It creates the client's payment method, and a payment method should
// not appear on somebody's record because a screen was opened. It also disappears the moment it has
// been used, so there is nothing to press twice.
//
// The office permission is re-checked on the server. This control only decides what to offer.
const AffiliateBilling = ({ userId, affiliateBilled, hasBilling, onAdded }) => {
  const dispatch = useDispatch()
  const [adding, setAdding] = useState(false)

  if (!affiliateBilled || hasBilling) return null

  const add = async () => {
    setAdding(true)
    try {
      const result = await dispatch(addAffiliateBilling(userId))

      // A rep who sees nothing happen assumes the button is broken and presses it again.
      if (result?.error) {
        showSnackBar('error', result.error.message || 'Could not add affiliate billing')
        return
      }

      // Re-read the client, or the LSA controls stay hidden until a manual refresh.
      await onAdded?.()
    } finally {
      setAdding(false)
    }
  }

  return (
    <div className="flex flex-col gap-2 mb-6">
      <span className="text-sm text-text-secondary">
        This client is billed to the affiliate. Adding it takes no bank account or card, and no
        payment is ever collected automatically — each one waits for someone to mark it paid.
      </span>
      <div>
        <Button disabled={adding} onClick={add} width="min-w-[220px]">
          {adding ? 'Adding…' : 'Billed to the affiliate'}
        </Button>
      </div>
    </div>
  )
}

export default AffiliateBilling
